module.exports = __webpack_public_path__ + "img/ar-tab4.c6c8733c.jpg";